import { GeoJSON } from 'highcharts'
import { getAbsoluteServerUrl } from '../config/config'
import { errorDeRespuesta } from './map-error.util'

/**
 * Census sections of one province.
 *
 * This is the level the map draws when the user zooms into a province. The endpoint builds
 * the geometry from the database, simplified and compressed, so it is a fraction of what
 * the generic `/map/geojson` query returns for the same province and it needs no files
 * copied by hand after an Atlas upload.
 */
export async function getProvinceSectionsGeojson(provinceId: number, signal?: AbortSignal): Promise<GeoJSON> {
  const response = await fetch(
    getAbsoluteServerUrl(`/map/provinces/${provinceId}/sections/geojson`),
    { signal }
  )

  if (response.ok) {
    return (await response.json()) as GeoJSON
  }

  // The status travels on the error so the map can explain what happened instead of going
  // blank: see avisoDeZona.
  throw errorDeRespuesta(response.status)
}
